<template>
  <span>{{ helper.formatCurrency(value) }}</span>
</template>

<script>
import { helper } from '../../Utilities/helper';

export default {
  props: {
    value: null,
  },
  data() {
    return {
      helper,
    };
  },
};
</script>